module["exports"] = [
  "Türkiye"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/tr/address/default_country.js
// module id = 2764
// module chunks = 2